const isUnacademy = (organizationID: number): boolean => {
  return organizationID === 12649;
};

export default isUnacademy;
